<div class="spinner-container">
    <p-progressSpinner></p-progressSpinner>
</div>